import apiClient from '../../config/axios';

export const cashCoursePaymentService = {
  /**
   * Crea una iscrizione al corso con pagamento in contanti
   * @param {Object} user - L'utente corrente
   * @param {Object} courseData - I dati del corso
   * @returns {Promise<Object>} - Risposta con successo o errore
   */
  createCashEnrollment: async (user, courseData) => {
    try {
      if (!user || !user._id) {
        return {
          success: false,
          error: 'Utente non autenticato.',
        };
      }
      const payload = {
        userId: user._id,
        courseId: courseData._id,
        amount: courseData.amount,
        paymentMethod: courseData.paymentMethod || 'cash',
        enrollmentStartDate: courseData.enrollmentStartDate,
      };
      const response = await apiClient.post('/api/enrollments', payload);
      return {
        success: true,
        enrollment: response.data,
        message: 'Iscrizione creata con successo',
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Errore nella creazione della iscrizione in contanti',
      };
    }
  },

  /**
   * Aggiorna l'utente con la nuova iscrizione
   * @param {Object} user - L'utente corrente
   * @param {Object} newEnrollment - La nuova iscrizione
   * @param {Function} updateUser - Funzione per aggiornare il contesto utente
   */
  updateUserWithEnrollment: (user, newEnrollment, updateUser) => {
    updateUser({
      ...user,
      enrollments: [...user.enrollments, newEnrollment]
    });
  },
}; 